"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const lodash_1 = require("lodash");
const react_1 = require("react");
const merchant_portal_components_1 = require("merchant-portal-components");
function calculateClassName({ className, pristine, invalid, submitting, }) {
    return (0, classnames_1.default)({
        'is-disabled': pristine || invalid,
        'in-progress': submitting,
    }, className);
}
function Button({ children, type, pristine, invalid, submitting, className, onClick, disabledToolTip = '', ...rest }, ref) {
    const disabled = pristine || invalid ? true : false;
    const message = disabled && disabledToolTip ? disabledToolTip : null;
    return ((0, jsx_runtime_1.jsx)(merchant_portal_components_1.AuthorizationTooltip, { displayed: disabled && !!message, message: message, children: (0, jsx_runtime_1.jsx)("button", { type: type, ref: ref, className: calculateClassName({
                className,
                pristine,
                invalid,
                submitting,
            }), "aria-disabled": disabled, onClick: disabled || submitting ? lodash_1.noop : onClick, ...rest, children: children }) }));
}
exports.default = (0, react_1.forwardRef)(Button);
